import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, FormButton, FormField, Input, Label } from "semantic-ui-react";
import { useSetupCallRecordingApi } from "../../hooks/useSetupCallRecordingApi";
import { style } from "../../style";

const CallRecordingApiSetupForm = () => {
  const [details, setDetails] = useState({
    api_url: "",
    api_key: "",
    username: "",
    password: "",
  });

  const navigate = useNavigate();
  const { setupCallRecordingApiMutate, isLoading, formErrors } =
    useSetupCallRecordingApi(() => navigate(0));

  const handleSubmit = () => {
    setupCallRecordingApiMutate(details);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormField>
        <label>API URL</label>
        {"api_url" in formErrors && (
          <Label color="red">{formErrors?.api_url}</Label>
        )}
        <Input
          value={details.api_url}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, api_url: value })
          }
        />
      </FormField>
      <FormField>
        <label>API Key</label>
        {"api_key" in formErrors && (
          <Label color="red">{formErrors?.api_key}</Label>
        )}
        <Input
          type="password"
          value={details.api_key}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, api_key: value })
          }
        />
      </FormField>
      <FormField>
        <label>Username</label>
        {"username" in formErrors && (
          <Label color="red">{formErrors?.username}</Label>
        )}
        <Input
          value={details.username}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, username: value })
          }
        />
      </FormField>
      <FormField>
        <label>Password</label>
        {"password" in formErrors && (
          <Label color="red">{formErrors?.password}</Label>
        )}
        <Input
          type="password"
          value={details.password}
          disabled={isLoading}
          onChange={(e, { value }) =>
            setDetails({ ...details, password: value })
          }
        />
      </FormField>
      <FormButton
        type="submit"
        disabled={isLoading}
        loading={isLoading}
        style={{ ...style.gradientButton, width: "100%" }}
      >
        Save
      </FormButton>
    </Form>
  );
};

export default CallRecordingApiSetupForm;
